import React from "react";
import { useTranslation } from "react-i18next";
import ErrorFallback from "src/components/reusable/ErrorFallback/ErrorFallback";

interface RequireSectionAccessProps {
  children: React.ReactNode;
  /** Access check for this section, e.g. `hasUserManagementAccess`. */
  hasAccess: () => boolean;
}

/**
 * Blocks a route the current user has no access to. Hiding the sidebar link is
 * not enough on its own — without this the page is still reachable by URL.
 */
const RequireSectionAccess: React.FC<RequireSectionAccessProps> = ({
  children,
  hasAccess,
}) => {
  const { t } = useTranslation();

  if (!hasAccess()) {
    return (
      <ErrorFallback
        title={t("accessDenied.title")}
        message={t("accessDenied.message")}
      />
    );
  }

  return <>{children}</>;
};

export default RequireSectionAccess;
